/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet ,Image } from '@react-pdf/renderer';
import userprofile from '../../../images/user.png';

const borderColor = '#3778C2';
const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: 60,

	},

	Id: {
		width: '5%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		height:'100%',
		fontSize:'8px',
		textAlign:'center',
		padding :'10px',
	},

	Name: {
		width: '20%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		height:'100%',
		fontSize:'8px',
		marginRight : '10px',
		textAlign:'center',
		paddingTop :'10px',
	},
		
	Email: {
		width: '24%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		height:'100%',
		fontSize:'8px',
		// marginRight : '10px',
		textAlign:'left',
		justifyContent :'center',
		display : 'flex',
		paddingTop :'10px',

	},
	Usertype: {
		width: '20%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		height:'100%',
		fontSize:'8px',
		marginRight : '8px',
		textAlign:'left',
		padding :'10px',
	},

	endborder: {
		flexDirection: 'row',
		borderBottomColor: '#3778C2',
		borderBottomWidth: 1,
		alignItems: 'center',
		textAlign: 'right',
		paddingRight: 8,
		fontSize: '8px',
		width:'100%'
	},
	CellPhone: {
		width: '14%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		height:'100%',
		fontSize:'8px',
		marginRight : '10px',
		textAlign:'left',
		padding :'10px'
	},

	logo: {
		// width: '14%',
		height: 50,
		margin:'10px'
	},
});
const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View 
			key={index}
			style={{ pageBreakInside: 'avoid' }}   // keeps row + border together
		>
			<View style={styles.row}>
				<Text style={styles.Id}>{item.id}</Text>
				<Text style={styles.Name}>{`${item.firstName} ${item.lastName}`}</Text>
				<Text style={styles.Email}>{item.email}</Text>
				<Text style={styles.CellPhone}>{item.cellPhone}</Text>
				<Text style={styles.Usertype}>{item.usertype}</Text>

				<Image
					style={styles.logo}
					src={
						item.profileImageUrl?.trim()
							? item.profileImageUrl
							: userprofile
					}
				/>
			</View>

			{/* Row bottom border */}
			<Text style={styles.endborder}></Text>
		</View>
	));

	return <>{rows}</>;
};


export default InvoiceTableRow;